// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3213":"07307aa2","6415":"07307aa2","8810":"cc258eb1"}[chunkId] + ".chunk.css";
};